import React from 'react';
import LoggedIn from './LoggedIn.js';

const UnprotectedView = () => {
  return <LoggedIn />;
};

export default UnprotectedView;
